import { BadgesTypes, type BadgeType } from './constants';

type UseBadgeScoreReturn = { data: BadgeType };

const BADGE_THRESHOLDS = [
	{ min: 10, type: BadgesTypes.GREAT },
	{ min: 7, type: BadgesTypes.GOOD },
	{ min: 4, type: BadgesTypes.ROOM_TO_IMPROVE },
	{ min: -Infinity, type: BadgesTypes.BELOW_AVERAGE },
];

export const useBadgeScore = (score: number): UseBadgeScoreReturn => {
	const threshold = BADGE_THRESHOLDS.find((bThreshold) => score >= bThreshold.min);
	if (!threshold) {
		throw new Error('Unreachable: a badge threshold should always be found');
	}
	return { data: { ...threshold.type } };
};
